import {clsx} from "clsx";
import IMG from "../../constants/image";
import ImageBasic from "../Common/Image/ImageBasic";

const Pagination = ({currentPage, totalPages, onPageChange, className}) => {
    // Create array of pages to display
    const getPageNumbers = () => {
        const pages = [];
        // Display up to 5 pages
        const maxPagesToShow = 5;

        if (totalPages <= maxPagesToShow) {
            // If total number of pages is less than or equal to 5, display all
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Show 5 pages around current page
            let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
            let endPage = startPage + maxPagesToShow - 1;

            // Adjust if endPage exceeds totalPages
            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(1, endPage - maxPagesToShow + 1);
            }

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
        }

        return pages;
    };
    return (
        <div className={clsx("flex justify-center items-center py-4 space-x-2", className)}>
            <div className='text-sm'>Trang</div>
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`w-7 h-7 md:w-9 md:h-9 rounded-md ${currentPage === 1 ? 'cursor-not-allowed' : 'md:hover:bg-[#F8C518]'}`}
            >
                <ImageBasic
                    src={IMG.icon.chevronRightPagination}
                    alt="next"
                    className="w-2 h-3 mx-auto rotate-180"
                />
            </button>

            {getPageNumbers().map(page => (
                <button
                    key={page}
                    onClick={() => onPageChange(page)}
                    className={`w-7 h-7 md:w-9 md:h-9 rounded-md text-sm ${
                        currentPage === page
                            ? 'bg-[#F8C518] text-white font-bold'
                            : 'text-gray-700 md:hover:bg-[#F8C518] md:hover:text-white'
                    }`}
                >
                    {page}
                </button>
            ))}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`w-7 h-7 md:w-9 md:h-9 rounded-md ${currentPage === totalPages ? 'cursor-not-allowed' : 'md:hover:bg-[#F8C518]'}`}
            >
                <ImageBasic
                    src={IMG.icon.chevronRightPagination}
                    alt="next"
                    className="w-2 h-3 mx-auto"
                />
            </button>
        </div>
    );
};
export default Pagination;